import apiClient from '@/utils/apiClient';

const TEMPLATE_API_ENDPOINTS = {
	getIntegrationByServiceName: (serviceName: string) =>
		`/api/template-workflow/integration/${encodeURIComponent(serviceName)}`,
};

export const getHousecallproTemplate = async (serviceName: string) => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: TEMPLATE_API_ENDPOINTS.getIntegrationByServiceName(serviceName),
	});
	return response || {};
};
